// Standard ink-bordered detail card. Inner gap of 8px between section title
// and contents. Use SectionTitle as the first child for a labelled card.

export function Card({ children, className = '', style }) {
  return (
    <div
      className={`border border-ink p-3 bg-paper grid gap-2 ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export default Card;
